/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface TicketingSettings
 */
export interface TicketingSettings {
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof TicketingSettings
     */
    carrier?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {boolean}
     * @memberof TicketingSettings
     */
    instantTicketing?: boolean;
}

export function TicketingSettingsFromJSON(json: any): TicketingSettings {
    return TicketingSettingsFromJSONTyped(json, false);
}

export function TicketingSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketingSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'carrier': !exists(json, 'carrier') ? undefined : GuidIdCodeAndLabelFromJSON(json['carrier']),
        'instantTicketing': !exists(json, 'instantTicketing') ? undefined : json['instantTicketing'],
    };
}

export function TicketingSettingsToJSON(value?: TicketingSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'carrier': GuidIdCodeAndLabelToJSON(value.carrier),
        'instantTicketing': value.instantTicketing,
    };
}


